import { confirmSignIn, resendCode, signOut } from './SignInConfirm.commands';
import {
    getCodeDeliveryDetails,
    isSMSEnabled,
    isTOTPEnabled,
} from '/b2b/authentication/state/amplify/Amplify.selectors';
import {
    resendPhoneVerificationCode,
    verify as verifyPhone,
} from '../../SelectMFA/VerifyPhone/VerifyPhone.commands';

import { getMfaType } from '/b2b/authentication/state/Auth.selectors';

export const mapStateToProps = (state, ownProps) => {
    const mfaType = ownProps?.mfaType ?? getMfaType(state);
    return {
        mfaType,
        isSMSEnabled: isSMSEnabled(state),
        isTOTPEnabled: isTOTPEnabled(state),
        codeDeliveryDetails: getCodeDeliveryDetails(state, mfaType),
    };
};

export const mapDispatchToProps = {
    confirmSignIn,
    resendCode,
    resendPhoneVerificationCode,
    signOut,
    verifyPhone,
};

export const mergeProps = (stateProps, dispatchProps) => {
    let resendCode = dispatchProps.resendCode;
    let confirmSignIn = dispatchProps.confirmSignIn;
    switch (stateProps.mfaType) {
        case 'SMS':
            if (!stateProps.isSMSEnabled) {
                resendCode = dispatchProps.resendPhoneVerificationCode;
                confirmSignIn = dispatchProps.verifyPhone;
            }
            break;
    }
    return {
        ...stateProps,
        signOut: dispatchProps.signOut,
        confirmSignIn,
        resendCode,
    };
};
